import request from "@/utils/request";

// 会员获取用户详细信息
export function getInfo(id) {
  return request({
    url: "/api/MemberInfo/Get",
    method: "get",
    params: { id }
  });
}

// 用户自身获取详细信息
export function getOwnInfo(id) {
  return request({
    url: "/api/MemberInfo/GetOwnInfo",
    method: "get",
    params: { id }
  });
}

// 红娘获取用户详细信息
export function getMatchmakerViewMemberInfo(id) {
  return request({
    url: "/api/MemberInfo/MatchmakerViewMemberInfo",
    method: "get",
    params: { memberInfoId: id }
  });
}

export function getVerificationCode(params) {
  return request({
    url: "/api/Login/GetVerificationCode",
    method: "get",
    params: params
  });
}

// 用户登录
export function login(params) {
  return request({
    url: "/api/Login/Login",
    method: "post",
    data: params
  });
}
// 自动登录
export function autoLogin(params) {
  return request({
    url: "/api/Login/AutoLogin",
    method: "get",
    params: params
  });
}

// 获取非登录用户更新信息
export function updateLogin() {
  return request({
    url: "/api/Login/RefreshToken",
    method: "get"
  });
}

// 用户更新数据
export function updateUserInfo(data) {
  return request({
    url: "/api/MemberInfo/Update",
    method: "post",
    data: data
  });
}
// 上传
export function upLoadImages(data) {
  return request({
    url: "/api/FileUpload/UpLoadImages",
    method: "post",
    data: data
  });
}
export function submitPersonInfo(data) {
  let { descriptionOfPersonalInterests, birthday, expectedMarriageDate } = data;
  descriptionOfPersonalInterests = descriptionOfPersonalInterests.join(",");
  birthday = new Date(birthday).toISOString();
  expectedMarriageDate = expectedMarriageDate ? new Date(expectedMarriageDate).toISOString() : null;
  return request({
    url: "/api/MemberInfo/Create",
    method: "post",
    data: { ...data, descriptionOfPersonalInterests, birthday, expectedMarriageDate }
  });
}
export function getMemberList(params) {
  return request({
    url: "/api/MemberInfo/GetMemberInfoListFromAppByPage",
    method: "post",
    data: { ...params }
  });
}

export function submitMatchMakerInfo(data) {
  let { reasonForJoining } = data;
  reasonForJoining = reasonForJoining.join(",");
  return request({
    url: "/api/MatchmakerInfo/Create",
    method: "post",
    data: { ...data, reasonForJoining }
  });
}
// 删除会员--退会
export function deleteMember(data) {
  return request({
    url: "/api/MemberInfo/Delete",
    method: "post",
    data: data
  });
}
export function getFollowUpMembers(data) {
  return request({
    url: "/api/MemberInfo/GetFollowUpMemberInfoListByPage",
    method: "post",
    data: data
  });
}
// 浏览记录
export function createBrowsingHistory(data) {
  return request({
    url: "/api/MemberInfo/CreateBrowsingRecords",
    method: "post",
    data: data
  });
}
export function getBrowsingHistory(id) {
  return request({
    url: "/api/MemberInfo/GetBrowsingRecordsByMemberInfoId",
    method: "get",
    params: { memberInfoId: id }
  });
}

export function getDefaultCoverInfo() {
  return request({
    url: "/api/CoverInfo/GetDefaultCoverInfo",
    method: "get"
  });
}

export function getInternalRawDataQueryByOaToken(params) {
  return request({
    url: "/api/InternalRawDataQuery/GetInternalRawDataQueryByOaToken",
    method: "get",
    params: params
  });
}

export function getEmployeeInfoByEmployeeNo(employeeNo) {
  return request({
    url: "/api/InternalRawDataQuery/GetEmployeeInfoByEmployeeNo",
    method: "get",
    params: {employeeNo: employeeNo}
  });
}

// 微信登录（openid免登）
export function weChatLogin(data) {
  return request({
    url: "/api/Login/WeChatLogin",
    method: "post",
    data: data
  });
}

// 绑定微信到已有会员账号
export function bindWeChatToExistingMember(data) {
  return request({
    url: "/api/Login/BindWeChatToExistingMember",
    method: "post",
    data: data
  });
}

// 获取所有系统预设标签
export function getAllTags() {
  return request({
    url: `/api/PersonTag/GetAllTags`,
    method: "get"
  });
}

// 获取会员已选标签
export function getMemberTags(memberId) {
  return request({
    url: `/api/PersonTag/GetMemberTags/${memberId}`,
    method: "get"
  });
}

// 保存会员性格标签
export function savePersonalityTags(data) {
  return request({
    url: "/api/PersonTag/SaveMemberPersonalityTags",
    method: "post",
    data: data
  });
}

// 保存会员择偶要求标签
export function saveSpouseRequirementTags(data) {
  return request({
    url: "/api/PersonTag/SaveMemberSpouseRequirementTags",
    method: "post",
    data: data
  });
}

// 遇见页面-获取异性会员列表
export function getEncounterMemberList(params) {
  return request({
    url: "/api/MemberInfo/GetMemberInfoListFromAppByPage",
    method: "post",
    data: params
  });
}

// 智能推荐-获取智能推荐会员列表
export function getSmartRecommendMembers(params) {
  return request({
    url: "/api/MemberInfo/GetSmartRecommendMembers",
    method: "post",
    data: params
  });
}

// 获取大模型生成的会员一句话总结
export function getMemberSummary(memberInfoId) {
  return request({
    url: "/api/AI/GetMemberSummary",
    method: "get",
    params: { memberInfoId }
  });
}

// AI智能匹配-获取大模型匹配的会员列表
export function getAiMatchMembers(params) {
  return request({
    url: "/api/AI/GetAiMatchMembers",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js